import React from 'react';
import { ComparisonMode } from '../../../utils/analytics/comparison';

interface ComparisonSelectorProps {
  value: ComparisonMode;
  onChange: (mode: ComparisonMode) => void;
}

const OPTIONS: Array<{ id: ComparisonMode; label: string }> = [
  { id: 'none', label: 'No compare' },
  { id: 'prior', label: 'Prior period' },
  { id: 'yoy', label: 'Last year' },
];

const ComparisonSelector: React.FC<ComparisonSelectorProps> = ({ value, onChange }) => (
  <div className="analysis-toggle-group" role="group" aria-label="Comparison">
    {OPTIONS.map(option => (
      <button
        key={option.id}
        type="button"
        className={value === option.id ? 'active' : ''}
        onClick={() => onChange(option.id)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default ComparisonSelector;
